import { useEffect, useState } from "react";

function BarcodeReader({ handleReader, model = "product.product", data }) {
  const [readerConnected, setReaderConnected] = useState(false);

  useEffect(() => {
    if (!("hid" in navigator)) {
      console.warn("WebHID no soportado en este navegador");
      return;
    }

    const checkDevices = async () => {
      const devices = await navigator.hid.getDevices();

      if (devices.length > 0) {
        setReaderConnected(true);

        devices.forEach((device) => {
          device.addEventListener("inputreport", (event) => {
            const { data: reportData } = event;
            let text = "";

            for (let i = 0; i < reportData.byteLength; i++) {
              const byte = reportData.getUint8(i);
              if (byte >= 32 && byte <= 126) {
                text += String.fromCharCode(byte);
              }
            }

            if (text.trim().length > 0) {
              if (data) data.value = text.trim();
              handleReader(text.trim());
            }
          });
        });
      }
    };

    checkDevices();
  }, []);

  useEffect(() => {
    let buffer = "";
    let lastTime = Date.now();
    const input = document.getElementById("barcode-reader");

    const handleKey = (e) => {
      const now = Date.now();

      if (now - lastTime > 50) buffer = "";
      lastTime = now;

      if (e.key === "Enter") {
        const code = buffer.trim();
        console.log("code", code);

        if (code) {
          if (data) data.value = code;
          handleReader(code);
        }

        buffer = "";
        if (input) input.value = "";
        return;
      }

      buffer += e.key;
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [handleReader, data]);

  const requestHID = async () => {
    try {
      const devices = await navigator.hid.requestDevice({
        filters: [], // sin filtros → muestra todos los HID
      });

      console.log("Dispositivos permitidos:", devices);
      setReaderConnected(true);
    } catch (err) {
      console.error("Permiso denegado o error:", err);
    }
  };

  return (
    <div>
      <div className="flex bg-gray-100 border border-gray-300 shadow-md rounded-2xl px-5 py-1 justify-center items-center absolute bottom-3 right-4 w-fit space-x-2 text-gray-700">
        <span>
          {readerConnected ? "Lector HID conectado" : "Esperando lector…"}
        </span>

        <div
          className={
            readerConnected
              ? "size-3 animate-ping bg-green-400 border border-green-950 rounded-full"
              : "size-3 bg-red-400 border border-red-950 rounded-full"
          }
        />

        {!readerConnected && "hid" in navigator && (
          <button onClick={requestHID} className="underline">
            Activar HID
          </button>
        )}

        <input type="text" id="barcode-reader" className="hidden" autoFocus />
      </div>
    </div>
  );
}

export default BarcodeReader;
